import React, { forwardRef, useState, useEffect, useContext } from 'react'; import { Colors } from '../../../constants';
import { useTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/creatable';
import { ActionMeta, OnChangeValue } from 'react-select';
import { ToastContext } from '../../../contexts/toastContext';

// function to create the regular input element for name and email
const  InputGuestEmails = forwardRef((props, ref) => {
    const [ focusBorderColor, setFocusBorderColor ] = useState(`#${Colors.primaryColor}`);
    const { showError } = useContext(ToastContext);

    const components = {
      DropdownIndicator: null,
    };

    const [ showInput, setShowInput ] = useState(false);
    const [ inputValue, setInputValue ] = useState("");
    const [ value, setValue ] = useState([]);
    const { t } = useTranslation();

    const colourStyles: StylesConfig<ColourOption, true> = {
      control: (styles) => ({
        ...styles,
        // display: showInput ? 'block' : 'none',
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '0.4em 0',
        boxShadow: 'none',
        borderColor: focusBorderColor,
        ':hover': { borderColor: focusBorderColor}
      } ),
      multiValue: (styles, { data }) => {
        return {
          ...styles,
          backgroundColor: data.valid_email ? '#e5e5e5' : 'red',
        };
      },
      multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: data.valid_email ? '#000' : '#fff',
      }),
      multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: data.valid_email ? '#000' : '#fff',
      }),
    };

    useEffect(() => {
        setFocusBorderColor(`#${Colors.disabledText}`);
    },
    []);

    const handleChange = (
        value: OnChangeValue<Option, true>,
        actionMeta: ActionMeta<Option>
    ) => {
        setValue(value);
    };

    const handleInputChange = (inputValue: string) => {
        setInputValue({ inputValue });
    };

    const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (event) => {
      if (!inputValue || inputValue.inputValue === "") return;
      switch (event.key) {
        case 'Enter':
        case 'Tab':
        case ' ':

          if ( (value.filter(item => item.valid_email ).length > 4) ) {
            showError('Maximum 5 guest emails');
          } else {
            let email = inputValue.inputValue;
            let updateValue = [ ...value, { label: email, value: email, valid_email: validateEmail(email) } ];
            setValue(updateValue);

            let valuefilter = updateValue.filter((i) => i.valid_email )
            let valueMap = valuefilter.map((i) => i.value)
            document.getElementById(`guestEmails`).value = valueMap.join()
          }

          setInputValue({inputValue: ""});
          event.preventDefault();
          break;
        default:
          break;
      }
    };

    const validateEmail = (email) => {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    return (
      <div className="input-section" key={props.index}>
        { !showInput && <button onClick={() => setShowInput(true)}>Add Guests</button> }
        <div className="input-nav field-label" style={{display: showInput ? 'block' : 'none' }}>
            <label>
                {t('Guest Email(s)')}
            </label>
            <div className="field-input">
                <CreatableSelect
                    ref={ref}
                    components={components}
                    inputValue={inputValue.inputValue}
                    placeholder=""
                    value={value}
                    isMulti
                    isClearable={false}
                    menuIsOpen={false}
                    onChange={handleChange}
                    onInputChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    className="guest-emails"
                    styles={colourStyles}
                    onFocus={ () => setFocusBorderColor(props.color) }
                    onBlur={ () => setFocusBorderColor(`#${Colors.disabledText}`) }
                />
            </div>
        </div>
        <input type="hidden" id="guestEmails" />
      </div>
    )
});

export default InputGuestEmails;
